/**
 * Created by shinan.chen on 2021/12/25.
 */
import { getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface ICard {
    id: number,
    name: string,
    remark: string,
    effectiveStartTime: Date,
    effectiveEndTime: Date,
    effectiveDay: number,
    costPrice: string,
    averageUnitPrice: string,
    cardDefinitionId: number,
    studentId: number,
    payWay: string,
    payWayName: string,
    sendGifts: Boolean,
    signContract: Boolean,
    studentName: string,
    courseMessage: string,
    cardCourses: ICardCourse[],
    valid: Boolean,
}

export interface ICardCourse {
    id: number,
    name: string,
    remark: string,
    value: number,
    cardId: number,
    courseDefinitionId: number,
}

export interface ICardPunchRecord {
    id: number,
    cardId: string,
    studentId: number,
    storeId: number,
    punchTime: Date,
    creationTime: Date,
    costValue: number,

    cardName: string,
    studentName: string,
    storeName: string,
    courseName: string,
    teachClassName: string,

    count: number,
}

export interface ITransformCourse {
    cardId: string,
    fromCourseDefinitionId: number,
    toCourseDefinitionId: number,
    value: number,
}

export interface ITransformNCourse {
    fromCardId: string,
    toCardId: string,
}

export const listCards = () =>
    getCommon({
        url: `${config.SERVICE_URL}/card/list_all`,
    });

export const createCard = (data: ICard) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/create`,
        data
    });

export const updateCard = (data: ICard) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/update`,
        data
    });

    export const updateEffectiveCard = (data: ICard) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/update_effective_end_time`,
        data
    });

    export const updateCostPrice = (data: ICard) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/update_cost_price`,
        data
    });

    
export const deleteCard = (id: number) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/delete?id=${id}`
    });

export const pageCards = (pageNum: number, pageSize: number, studentId?: any) =>
    getCommon({
        url: `${config.SERVICE_URL}/card/page?pageNum=${pageNum}&&pageSize=${pageSize}&&studentId=${studentId}`,
    });

export const pagePunchRecords = (pageNum: number, pageSize: number, studentId?: any) =>
    getCommon({
        url: `${config.SERVICE_URL}/card/punch_record/page?pageNum=${pageNum}&&pageSize=${pageSize}&&studentId=${studentId}`,
    });

export const createPunchRecord = (data: ICardPunchRecord) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/punch_record/create`,
        data
    });

    export const transformCourse = (data: ITransformCourse) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/transform_course`,
        data
    });

    export const transformNCourse = (data: ITransformNCourse) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/transform_negative_course`,
        data
    });

export const deletePunchRecord = (id: number) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/punch_record/delete?id=${id}`
    });

    export interface ICardCalculateCreateParam {
        cardDefinitionId: number,
        studentId: number,
        type: number,
        count: number,
    }

    export const calculateEffectiveEndTime = (data: ICardCalculateCreateParam) =>
    postCommon({
        url: `${config.SERVICE_URL}/card/calculate_effective_end_time`,
        data
    });